import type React from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

import { PetitionQRCodeDownload } from 'src/app/shared/components/qrcode';

import { usePetitionUrlQRCode } from './hooks/usePetitionUrlQRCode';

export const PetitionUrlQRCode: React.FC = () => {
	const { data } = usePetitionUrlQRCode();

	if (!data.shareAction) {
		return null;
	}

	const { ShareAction } = data.shareAction;

	return (
		<Box mt={24}>
			<ShareAction>
				<PetitionQRCodeDownload
					slugOrId={data.slugOrId}
					displaySize={data.displaySize}
					displayType={data.displayType}
					downloadType={data.downloadType}
					descriptionText={data.descriptionText}
					downloadLinkText={data.downloadLinkText}
					downloadFilename={data.downloadFilename}
				/>
			</ShareAction>
		</Box>
	);
};
